import React, { useState, useEffect, useRef } from 'react';

const MarginWidthDialog = ({ currentWidth, onConfirm, onCancel }) => {
  const [value, setValue] = useState(String(currentWidth));
  const inputRef = useRef(null);

  // Auto-focus and select the input text on mount
  useEffect(() => {
    inputRef.current?.select();
  }, []);

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onCancel();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onCancel]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const parsed = parseInt(value, 10);
    if (!isNaN(parsed) && parsed >= 2 && parsed <= 10) {
      onConfirm(parsed);
    }
  };

  return (
    <div className="dialog-overlay" onClick={onCancel}>
      <div className="dialog-card" onClick={(e) => e.stopPropagation()}>
        <h3 className="dialog-title">Margin Width</h3>
        <form onSubmit={handleSubmit}>
          <label className="dialog-label">
            Characters
            <input
              ref={inputRef}
              type="number"
              className="dialog-input"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              min="2"
              max="10"
            />
          </label>
          <div className="dialog-actions">
            <button type="button" className="dialog-button" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="dialog-button dialog-button-primary">
              OK
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MarginWidthDialog;
